<template>
    <el-footer>
      <div class="contain">
      <el-row :gutter="20">
        <el-col :span="13">
          <img src="../assets/logo-fff.png" alt="Logo" style="max-height: 100%;">
        </el-col>
        <el-col :span="6">
          <div class="footer-p">
            <p>主办：安徽师大教育发展集团</p>
            <p>运营：安徽杭颐教育咨询有限公司</p>
          </div>
        </el-col>
        <el-col :span="5">
        <img src="http://www.ahnuedu.cn/images/wx.jpg" />
        </el-col>
      </el-row>
      <p class="footer">版权所有：安徽师大教育发展集团</p>
      </div>
    </el-footer>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  props: {
  },
  watch: {
    
  },
  components: {
    
  },
  methods: {
    
  },
};
</script>

<style scoped>
  footer.el-footer{
    background-color: #238af1;
    color: #fff;
    min-height: 180px;
    padding-top: 20px;
  }
  footer .footer-p{
    margin-top: 20px;
  }

  footer .footer{
    text-align: center;
    border-top: 1px solid #ccc;
    padding-top: 10px;
    margin-top: 10px;
  }
</style>